import React, { useRef, useState } from 'react';
import { getClassNameFactory, Button } from '@dcl/ui';
import { propsToDataAttributes } from '@tr-digital/react-rehydrate';
import { ButtonKind, ButtonColor } from '@dcl/ui/dist/elements/Button';
import './VideoTabList.css';
import { IVideoTabListData } from '../../types';
import { IVideoPlaylistDetail } from '../../../../types';
import { ARROW_DOWN, ARROW_UP } from '../../constants';

export const VideoTabList: React.FC<IVideoTabListData> = (props) => {
  const getClassName = getClassNameFactory(VideoTabList.displayName);
  const { playListUserData, currentVideoHandler } = props;
  const [currentEntryId, setCurrentEntryId] = useState(
    playListUserData[0].entryId
  );

  const currentEntryIdHandler = (id: string) => {
    setCurrentEntryId(id);
  };

  const tabListReference = useRef<HTMLDivElement>(null);

  const changePanelContent = (currentListItem: IVideoPlaylistDetail) => {
    currentVideoHandler(currentListItem);
    currentEntryIdHandler(currentListItem.entryId);
  };

  const handleKeyEvents = (e: React.KeyboardEvent<HTMLButtonElement>) => {
    const tabList = tabListReference.current;
    if (!tabList) return;

    const tabElements: HTMLElement[] = Array.from(
      tabList.querySelectorAll('span[role=tab]')
    );

    let currentIndex = tabElements.indexOf(e.currentTarget);

    if (e.key === ARROW_DOWN) {
      tabElements[(currentIndex + 1) % tabElements?.length].focus();
    } else if (e.key === ARROW_UP) {
      if (currentIndex === 0) {
        currentIndex = tabElements.length;
      }
      tabElements[(currentIndex - 1) % tabElements?.length].focus();
    }
  };

  return (
    <div className={getClassName()} {...propsToDataAttributes(props)}>
      <div role="tablist" aria-orientation="vertical" ref={tabListReference}>
        {playListUserData.map((listItem) => (
          <div
            key={listItem.entryId}
            className={getClassName({
              descendantName: 'list',
            })}
          >
            <Button
              kind={ButtonKind.LINK}
              color={ButtonColor.TERTIARY}
              onClick={() => {
                changePanelContent(listItem);
              }}
              role="tab"
              ariaSelected={listItem.entryId === currentEntryId}
              aria-controls={listItem.entryId}
              tabIndex={listItem.entryId === currentEntryId ? 0 : -1}
              onKeyDown={(event) => {
                if (event.key === 'Enter') {
                  changePanelContent(listItem);
                } else {
                  handleKeyEvents(event);
                }
              }}
              disabled={false}
              active={listItem.entryId === currentEntryId}
              id={listItem.entryId}
              data-testid="video-tab-list"
            >
              {listItem.videoData?.videoTitle}
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
};

VideoTabList.displayName = 'VideoTabList';
